import { publicApiFetch } from '@/api/publicClient';

/**
 * Safe-to-expose tenant config served by GET /public/tenant-config, resolved
 * from the browser hostname. bamboo.etcho.io (prod) and bamboo.localhost
 * (dev) resolve to the Bamboo tenant through the identical backend path;
 * unknown hostnames resolve to the Etcho default.
 */
export type TenantBrandingColors = {
    primary: string;
    primaryContrast: string;
    accent: string;
    accentContrast: string;
    // Optional body-text override; branded themes default to black.
    text?: string | null;
};

export type TenantConfig = {
    tenantId: string;
    name: string;
    slug: string;
    branding: {
        logoUrl: string | null;
        logoLightUrl: string | null;
        faviconUrl: string | null;
        emailLogoUrl: string | null;
        pdfLogoUrl: string | null;
        colors: TenantBrandingColors;
        poweredByEtcho: boolean;
    };
    auth0OrgId: string | null;
};

export async function fetchTenantConfig(): Promise<TenantConfig | null> {
    try {
        const response = await publicApiFetch(
            `/public/tenant-config?hostname=${encodeURIComponent(
                window.location.hostname
            )}`
        );
        if (!response.ok) {
            return null;
        }
        return (await response.json()) as TenantConfig;
    } catch {
        // Null = Etcho defaults; login must render even if the config call
        // fails, so this is deliberately non-fatal.
        return null;
    }
}

// Kicked off at module load (before React renders) so the config races the
// rest of the bundle rather than blocking behind it.
export const tenantConfigPromise = fetchTenantConfig();
